import { Application } from "@hotwired/stimulus";
import smoothscroll from "smoothscroll-polyfill";
import * as Turbo from "@hotwired/turbo";
import Lightbox from "stimulus-lightbox";

import "../styles/index.scss";
import "lightgallery/css/lightgallery.css";

// kick off the polyfill!
smoothscroll.polyfill();

// Import controllers
import BoxController from "./controllers/box_controller.js";
import ScrolltoController from "./controllers/scrollto_controller.js";
import ExampleController from "./controllers/example_controller.js";

const application = Application.start();
application.register("box", BoxController);
application.register("scrollto", ScrolltoController);
application.register("example", ExampleController);
application.register("lightbox", Lightbox);
